import clsx from 'clsx'

import TopicRecommendation from './TopicRecommendation'
import InfoBox from './InfoBox'

import type { TAPIGetTopicRecommendation } from 'types/microlearning'

interface TopicRecommendationListProps {
  items: TAPIGetTopicRecommendation[]
  isLoading: boolean
  isError: boolean
  gridClassName?: string
}

const TopicRecommendationList = ({
  items,
  isLoading,
  isError,
  gridClassName,
}: TopicRecommendationListProps) => {
  if (isLoading) {
    return <TopicRecommendation isLoading={true} />
  }

  if (items && items.length) {
    return (
      <div className={clsx('grid grid-cols-1 gap-4', gridClassName)}>
        {(items || []).map((item, idx) => (
          <TopicRecommendation key={idx} {...item} />
        ))}
      </div>
    )
  }

  return (
    <div>
      <div className="flex items-start mb-2">
        <div className="flex items-center">
          <img
            src="https://storage.googleapis.com/microlearning-public-production/web-assets/img-book-literature.png"
            height={24}
            width={24}
            alt="Topik Bertema"
          />
        </div>
        <div className="flex-1 ml-2">
          <div className="font-semibold text-lg">Rekomendasi belajar</div>
        </div>
      </div>
      <InfoBox
        title={
          !isError
            ? 'Belum ada rekomendasi belajar'
            : 'Terjadi masalah dalam memuat rekomendasi belajar'
        }
        description={
          !isError
            ? 'Cobalah temukan di halaman daftar topik'
            : 'Silakan coba lagi dalam beberapa saat.'
        }
        isError={isError}
        isShowButton={!isError}
      />
    </div>
  )
}

export default TopicRecommendationList
